/* eslint-disable import/no-anonymous-default-export */
export default {
  comparison: "產品比較",
  comparison_humiture: "溫濕度計產品比較",
  comparison_air: "空氣檢測儀產品比較",
  buy: "購買",
  moreDetail: "進一步了解 >",
  batteryIcon: "電池圖標",
  probeIcon: "外接探頭",
  waterproofIcon: "防塵防水",
  supportAppIcon: "支持的 App",
  cp_supportApp_mi: '米家',
  cp_supportApp_mi_note: '僅支持米家的中國大陸伺服器。',
  cp_supportApp_plus: '青萍家',
  cp_supportApp_plus_note: '通過"青萍家" app 可管理青萍家用智能設備，支持查看數據、修改設置、升級固件等。',
  cp_supportApp_iot: '青萍物聯',
  cp_supportApp_iot_note: '通過青萍物聯可進行設備管理、數據收集、數據查詢、設置警報通知等。',
  cp_supportApp_plus_only_wifi_note: '僅 Wi-Fi 版本支持青萍家。',
  cp_supportApp_magpie: '李吉他溫濕度',
  cp_supportApp_appleHomeKit: '家庭',
  cp_supportApp_appleHomeKit_note: '通過蘋果“家庭” app 遠程查看，需配備 HomeKit 中樞設備，如 HomePod 或 Apple TV。',
  cp_supportApp_matter: 'Matter',
  display_eink: "電子墨水屏",
  display_segment: "低功耗段碼屏",
  display_size_50mm: "50 毫米",
  display_size_61x49mm: "61 × 49 毫米",
  display_size_64x44mm: "64.6 × 44.6 毫米",
  display_size_30x19mm: "30 × 19 毫米",
  detection_items: "檢測項目",
  comparison_display: "顯示屏",
  external_probe: "外接探頭",
  dust_proof_waterproof: "防塵防水",
  range: "量程",
  size_weight: "尺寸和重量",
  wireless_communication: "無線通訊",
  supported_apps: "支持的 App",
  supported_apps_protocol: "支持的 App 和協議",
  remote_monitoring: "遠程監測",
  power_and_battery_life: "供電方式",
  placement_and_installation: "擺放和安裝方式",
  cp_range_label_temp: "溫度：",
  cp_range_label_humidity: "濕度：",
  cp_goose3_display_type: "電子墨水屏",
  cp_duck3_display_type: "低功耗段碼屏",
  cp_pheasant_s_no_pressure_display_type: "低功耗段碼屏",
  cp_pheasant_s_display_type: "低功耗段碼屏",
  cp_frog_display_type: "低功耗段碼屏",
  cp_frog_display_size: "64 × 44 毫米",
  cp_frog_probe_desc: "外接溫度探頭",
  cp_frog_waterproof_desc: "主機：IP55 級防護",
  cp_frog_waterproof_desc2: "外接溫度探頭：IP68 級防護，可持續浸水使用",

  cp_frog_range_0_label: "主機溫度：",
  cp_frog_range_0_value_0: "-30 ~ 60°C（使用鋰鐵 5 號電池）",
  cp_frog_range_0_value_1: "-10 ~ 50°C（使用普通 5 號電池）",
  cp_frog_range_1_label: "主機濕度：",
  cp_frog_range_1_value_0: "0 ~ 100%RH（使用電池，無凝露環境）",
  cp_frog_range_1_value_1: "0 ~ 90%RH（使用 USB 供電，無凝露環境）",
  cp_frog_range_1_note: "請勿長時間在濕度超過 90% 的環境下使用。",
  cp_frog_range_2_label: "外接溫度探頭：",
  cp_frog_range_2_value: "-40 ~ 125℃",
  
  cp_frogs_waterproof_desc: '主機：IP56 級防護',
  cp_frogs_waterproof_desc2: '溫度探頭：IP68 級防護，可持續浸水使用',
  
  cp_frogs_probe_desc_0: '溫度探頭',
  cp_frogs_probe_desc_1: '高濃度二氧化碳探頭（扁線）',
  cp_frogs_range_0_title_0: "主機溫度",
  cp_frogs_range_0_title_1: "-30 ~ 60°C （使用鋰鐵 5 號電池或USB供電）",
  cp_frogs_range_0_title_2: "-10 ~ 50°C （使用普通 5 號電池）",
  cp_frogs_range_1_title_0: "主機濕度",
  cp_frogs_range_1_title_1: "0 ~ 100%RH",
  cp_frogs_range_1_note: "請勿長時間在濕度超過 90% 的環境下使用。",
  cp_frogs_range_2_title_0: "溫度探頭",
  cp_frogs_range_2_title_1: "-40 ~ 125℃",
  cp_frogs_range_3_title_0: "高濃度二氧化碳探頭（扁線）",
  cp_frogs_range_3_title_1: "0 ~ 25%",
  cp_frog_wireless_desc: "Wi-Fi 或 NB-IoT 或 LoRa",
  cp_frog_sizeWeight_0_items_0_label: "主機：",
  cp_frog_sizeWeight_0_items_1_label: "87.6 × 156.8 × 33 毫米（含天線）",
  cp_frog_sizeWeight_0_items_2_label: "118 克",
  cp_frog_sizeWeight_1_items_0_label: "外接溫度探頭：",
  cp_frog_sizeWeight_1_items_1_label: "傳感器探頭：",
  cp_frog_sizeWeight_1_items_1_value: "直徑 6 毫米，長度 50 毫米；",
  cp_frog_sizeWeight_1_items_2_label: "線身：",
  cp_frog_sizeWeight_1_items_2_value: "直徑 3.5 毫米，長度 1500 毫米；",
  cp_frog_sizeWeight_1_items_3_label: "吸盤式固定支架：",
  cp_frog_sizeWeight_1_items_3_value: "直徑 35 毫米，高 20 毫米",
  cp_frog_sizeWeight_1_items_4_label: "29 克",
  cp_frog_powerInfo_0_label: "5 號電池供電\nMicro-USB 接口供電",
  cp_frog_powerInfo_0_note: "可長期連接 Micro-USB 電源。不支持充電。",
  cp_frogs_powerInfo_0_label: '5 號電池供電\nUSB-C 接口供電',
  cp_frogs_powerInfo_0_note: '可長期連接 USB-C 電源。不支持充電。',
  cp_frog_mounting: "DIN 導軌固定、磁吸",
  cp_gecko_display_type: "低功耗段碼屏",
  cp_gecko_display_size: "30 × 19 毫米",
  cp_gecko_range_0_value: "-20 ~ 50℃",
  cp_gecko_wireless_desc: "NB-IoT",
  cp_gecko_sizeWeight_0_items_0_label: "86 × 86 × 38.5 毫米（牆外 11.5 毫米）",
  cp_gecko_sizeWeight_0_items_1_label: "126.8 克",
  cp_gecko_powerInfo_0_label: "牆壁接線盒供電",
  cp_gecko_powerInfo_1_label: "額定電壓：",
  cp_gecko_powerInfo_1_value: "250V 交流電",
  cp_gecko_powerInfo_2_label: "額定電流：",
  cp_gecko_powerInfo_2_value: "最大 10A",
  cp_gecko_powerInfo_3_note: " ",
  cp_gecko_mounting: "86 盒安裝",
  cp_gecko_mountingNote: "86 盒是一種接線盒規格，尺寸為 86 × 86 毫米。",
  cp_magpie_display_type: "電子墨水屏",
  cp_magpie_display_size: "26 × 26 毫米",
  cp_magpie_range_0_value: "0 ~ 50℃",
  cp_magpie_range_1_value: "0 ~ 99.9%RH（無凝露環境）",
  cp_magpie_range_1_note: "請勿長時間在濕度超過 90% 的環境下使用。",
  cp_magpie_wireless_desc: "藍牙",
  cp_magpie_sizeWeight_0_items_0_label: "131 × 37 × 12.4 毫米",
  cp_magpie_sizeWeight_0_items_1_label: "30 克（不含電池）",
  cp_magpie_powerInfo_0_label: "CR2032 鈕扣電池供電",
  cp_magpie_powerInfo_1_label: "續航長達 8 個月",
  cp_magpie_powerInfo_1_note: "在常見室溫環境下可持續使用 8 個月。實際續航時間可能依環境和電池的差異而有所不同。",
  cp_magpie_mounting: "磁吸模式",
  bluetooth_gateway_link: "青萍藍牙網關",

  cp_goose3_display_size: "50 毫米",
  cp_goose3_range_0_value: "0 ~ 50℃",
  cp_goose3_range_1_value: "0 ~ 99.9%RH（無凝露環境）",
  cp_goose3_range_1_note: "請勿長時間在濕度超過 90% 的環境下使用。",
  cp_goose3_wireless_desc: "藍牙",
  cp_goose3_sizeWeight_0_items_0_label: "70 × 70 × 19 毫米",
  cp_goose3_sizeWeight_0_items_1_label: "48 克（不含支架、電池）",
  cp_goose3_powerInfo_0_label: "7號電池供電",
  cp_goose3_powerInfo_1_label: "續航長達 12 個月",
  cp_goose3_powerInfo_1_note: "在常見室溫環境下可持續使用 12 個月。實際續航時間可能依環境和電池的差異有所不同。",
  cp_goose3_mounting: "桌面模式、牆面模式、磁吸模式",
  cp_duck3_display_size: "50 毫米",
  cp_duck3_range_0_value: "-9.9 ~ 50℃",
  cp_duck3_range_1_value: "0 ~ 99.9%RH（無凝露環境）",
  cp_duck3_range_1_note: "請勿長時間在濕度超過 90% 的環境下使用。",
  cp_duck3_wireless_desc: "藍牙",
  cp_duck3_sizeWeight_0_items_0_label: "70 × 70 × 19 毫米",
  cp_duck3_sizeWeight_0_items_1_label: "55 克（不含支架、電池）",
  cp_duck3_powerInfo_0_label: "7號電池供電",
  cp_duck3_powerInfo_1_label: "續航長達 12 個月",
  cp_duck3_powerInfo_1_note: "在常見室溫環境下可持續使用 12 個月。實際續航時間可能依環境和電池的差異有所不同。",
  cp_duck3_mounting: "桌面模式、牆面模式、磁吸模式",
  cp_pheasant_s_no_pressure_display_size: "61 × 49 毫米",
  cp_pheasant_s_no_pressure_range_0_value: "-30 ~ 55℃",
  cp_pheasant_s_no_pressure_range_1_value: "0 ~ 99.9%RH（無凝露環境）",
  cp_pheasant_s_no_pressure_range_1_note: "請勿長時間在濕度超過 90% 的環境下使用。",
  cp_pheasant_s_no_pressure_range_2_title_0: "氣壓：30 ~ 125 kPa",
  cp_pheasant_s_no_pressure_wireless_desc: "Wi-Fi 或 NB-IoT 或 LoRa",
  cp_pheasant_s_no_pressure_sizeWeight_0_items_0_label: "77 × 77 × 28 毫米",
  cp_pheasant_s_no_pressure_sizeWeight_0_items_1_label: "129 克",
  cp_pheasant_s_no_pressure_powerInfo_0_label: "USB-C 接口供電\n大容量可充電鋰電池",
  cp_pheasant_s_no_pressure_mounting: "牆面模式",
  cp_pheasant_s_display_size: "61 × 49 毫米",
  cp_pheasant_s_waterproof_desc: "主機：IP55 級防護\n外接溫度探頭：IP68 級防護，可持續浸水使用",
  cp_pheasant_s_range_0_value: "-20 ~ 50℃",
  cp_pheasant_s_range_1_value: "0 ~ 99.9%RH（無凝露環境）",
  cp_pheasant_s_range_1_note: "請勿長時間在濕度超過 90% 的環境下使用。",
  cp_pheasant_s_range_2_label:'氣壓：',
  cp_pheasant_s_range_2_value: '30 ~ 125 kPa',
  cp_pheasant_s_wireless_desc: "Wi-Fi 或 NB-IoT 或 LoRa",
  cp_pheasant_s_sizeWeight_0_items_0_label: "77 × 77 × 28 毫米",
  cp_pheasant_s_sizeWeight_0_items_1_label: "129 克",
  cp_pheasant_s_powerInfo_0_label: "USB-C 接口供電\n大容量可充電鋰電池",
  cp_pheasant_s_mounting: "牆面模式",
  detection_text_mi: "米家：需配備米家藍牙網關設備，如{bluetoothGatewayLink}。支持與其他米家設備聯動。",
  detection_text_plus_iot: "青萍家 和青萍物聯：需配備{bluetoothGatewayLink}。",
  detection_text_iot: "透過青萍物聯可進行設備管理、數據收集、數據查詢、設定警報通知等。",
  detection_text_magpie: "李吉他溫濕度和青萍家：需配備{bluetoothGatewayLink}。",
  pheasant_s_no_pressure: '青萍商用溫濕度計 S',
  
  // frogs sizeWeight
  cp_frogs_sizeWeight_0_items_0_label: '主機',
  cp_frogs_sizeWeight_0_items_1_value: '208 × 80 × 33 毫米（含天線）',
  cp_frogs_sizeWeight_0_items_2_value: '128 克',

  cp_frogs_sizeWeight_1_items_0_label: '溫度探頭',
  cp_frogs_sizeWeight_1_items_1_value: '傳感器探頭：直徑 6 毫米，長度 50 毫米',
  cp_frogs_sizeWeight_1_items_2_value: '線身：直徑 5 毫米，長度 1500 毫米',
  cp_frogs_sizeWeight_1_items_3_value: '連接器：長度 35 毫米',
  cp_frogs_sizeWeight_1_items_4_value: '57 克',

  cp_frogs_sizeWeight_2_items_0_label: '高濃度二氧化碳探頭（扁線）',
  cp_frogs_sizeWeight_2_items_1_value: '傳感器探頭：直徑 21 毫米，長度 51 毫米',
  cp_frogs_sizeWeight_2_items_2_value: '線身：1.5 × 4 毫米，長度 1500 毫米',
  cp_frogs_sizeWeight_2_items_3_value: '連接器：長度 35 毫米',
  cp_frogs_sizeWeight_2_items_4_value: '35 克',
};
